import moment from 'moment';
export default {
  data () {
    return {
      availableTimes: [
        {start: '07:00', end: '09:00'},
        {start: '09:00', end: '11:00'},
        {start: '11:00', end: '13:00'},
        {start: '13:00', end: '15:00'},
        {start: '15:00', end: '17:00'},
        {start: '17:00', end: '19:00'}
      ],
      availables: [],
      backgrounds: []
    }
  },
  methods: {
    getAvailables () {
      var app = this;
      return new Promise((resolve, reject) => {
        this.$http
        .get('service/agenda/available')
        .then(response => {
          app.availables = response.data;
          this.updateAvailables(app);
          resolve(app.backgrounds);
        })
        .catch(function (error) {
          console.log('catch:', error);
        });
      });
    },
    updateAvailables (app) {
      console.log('updateAvailables');
      app.backgrounds = [];
      app.availables.forEach(function (a) {
        var available = a.available ? a.available.split(',').map(Number) : null;
        if (available) {
          available.forEach(function (i) {
            app.backgrounds.push({
              type: 'background',
              group: a.driverId,
              className: 'available',
              start: moment(a.date + ' ' + app.availableTimes[i].start, 'YYYY-MM-DD HH:mm'),
              end: moment(a.date + ' ' + app.availableTimes[i].end, 'YYYY-MM-DD HH:mm')
            });
          })
        }
      })
      return app.backgrounds;
    }
  }
}
